// extracted by mini-css-extract-plugin
export var bounce = "_oi-1";
export var generatingText = "_oi-6";
export var lightning = "_oi-4";
export var popup = "_oi-5";
export var progressBar = "_oi-7";
export var progressFill = "_oi-8";
export var progressShimmer = "_oi-9";
export var progressText = "_oi-a";
export var shimmer = "_oi-3";
export var uploadIcon = "_oi-0";
export var uploadingText = "_oi-2";